import { DriverStatusProvider } from "./DriverStatusContext";
import DriverStatusTable from "./DriverStatusTable";
import DriverStatusPanel from "./components/DriverStatusPanel";

const DriverStatusPage = () => {
    return (
        <DriverStatusProvider>
            <DriverStatusPanel>
                <DriverStatusTable />
            </DriverStatusPanel>
        </DriverStatusProvider>
    );
};
export default DriverStatusPage;
